module.exports = __webpack_public_path__ + "img/HK_Lockup_RGB_Schwarz.27712d19.svg";